import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const CafeIcon = ({ className = '', width = 21,  height = 22 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 21 22'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M6.52221 7.73203L2.00101 2.33064L2.77075 1.68317L7.29195 7.08455L6.52221 7.73203Z'
                fill={color}
                fillRule='evenodd'/>
            <path
                d='M10.3953 10.793L11.0512 11.5765L11.707 10.793L11.0512 10.0095L10.3953 10.793Z'
                fill={color}/>
            <path
                d='M11.707 12.36L12.3628 13.1435L13.0187 12.36L12.3629 11.5765L11.707 12.36Z'
                fill={color}/>
            <path
                clipRule='evenodd'
                d='M4.00203 0.647471L4.77176 0L7.67904 3.47326L8.24578 4.15072C8.59637 4.5697 9.08073 5.14834 9.61578 5.78704C10.275 6.57396 10.2988 7.39344 10.1503 7.99973C10.0868 8.2591 9.99277 8.47873 9.9077 8.6434L11.0512 10.0095L10.3953 10.793L8.64526 8.70224L8.89286 8.38319L8.89574 8.37926C8.89947 8.3741 8.90626 8.36456 8.91539 8.35093C8.93372 8.32358 8.96109 8.28044 8.99208 8.22401C9.05477 8.10986 9.12816 7.94881 9.17447 7.75965C9.26358 7.39567 9.25734 6.92548 8.8463 6.43482C8.3111 5.79595 7.82662 5.21715 7.47595 4.79808L4.00203 0.647471ZM13.9919 11.1977L14.5511 10.5296C15.9369 10.4895 17.7377 9.70014 19.3297 7.79818C20.1766 6.78635 20.7533 5.67065 20.9374 4.63109C21.1224 3.58596 20.9135 2.55584 20.096 1.86814C19.3295 1.22346 18.3429 0.995229 17.2911 1.26007C16.2549 1.52101 15.1851 2.25035 14.1724 3.46012C12.5614 5.38482 12.2213 7.21089 12.3155 8.49926L11.6825 9.2552L11.0512 10.0095L11.707 10.793L11.0512 11.5765L11.707 12.36L12.3629 11.5765L13.0187 12.36L12.3628 13.1435L17.9486 19.8168L17.1798 20.4635L11.7077 13.9261L11.0518 14.7096L10.3961 13.9262L11.0519 13.1427L10.3961 12.3591L9.74023 11.5756L7.87642 9.34895L7.52 9.53799L7.51563 9.54015C7.50992 9.54294 7.49936 9.54798 7.48439 9.55463C7.45434 9.56798 7.4072 9.58751 7.34638 9.6083C7.22336 9.65037 7.0524 9.69486 6.85852 9.70773C6.48548 9.7325 6.02465 9.64468 5.61401 9.15369C5.07931 8.51439 4.59484 7.9356 4.24404 7.51663L0.769737 3.36634L0 4.01381L2.90727 7.48707L3.4744 8.16422C3.82512 8.58309 4.30947 9.16173 4.84401 9.80086C5.5026 10.5883 6.30353 10.7541 6.92492 10.7128C7.19075 10.6952 7.42285 10.6404 7.59939 10.585L9.08438 12.3591L2.64011 20.058L4.17958 21.3529L4.94887 22L11.0518 14.7096L17.0559 21.8826L19.3647 19.9405L18.7188 19.1689L13.0187 12.36L13.9919 11.1977ZM13.5449 10.1643L14.3147 10.8118L13.9919 11.1977L13.2221 10.5503L13.5449 10.1643ZM13.5449 10.1643L12.3629 11.5765L11.707 10.793L12.4522 9.90267L13.3595 8.81909L13.3344 8.60341C13.2152 7.5775 13.4182 5.92832 14.9422 4.10759C15.8672 3.00249 16.7676 2.4305 17.5359 2.23701C18.2888 2.04743 18.9411 2.21168 19.4501 2.63977C19.9078 3.02483 20.0922 3.64042 19.948 4.45508C19.8028 5.27531 19.3277 6.23348 18.5599 7.15071C17.0213 8.98885 15.374 9.56206 14.3368 9.52195L14.0908 9.51243L13.5449 10.1643ZM10.3961 13.9262L4.82547 20.5813L4.05573 19.9338L9.74023 13.1427L10.3961 13.9262Z'
                fill={color}
                fillRule='evenodd'/>
            <path
                d='M11.7077 13.9261L11.0519 13.1427L10.3961 13.9262L11.0518 14.7096L11.7077 13.9261Z'
                fill={color}/>
            <path
                d='M14.3147 10.8118L13.5449 10.1643L13.2221 10.5503L13.9919 11.1977L14.3147 10.8118Z'
                fill={color}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default CafeIcon;
